import * as _ from 'underscore';
import { FeatureFlags } from '../../../ts/FeatureFlags';
import {
  FlowDefinition,
  MetricDefinition,
  MixedContentInOrder,
  MixedContentItemDefinition,
  PublishedConnectionDefinition,
  ViewDefinition,
  WorkbookDefinition
} from '../../../ts/models/ContentDefinitions';
import { ExplorableItemType } from '../../../ts/models/ContentType';

export namespace FilterByTypeDropdownHelpers {
  export const getContentDefinitions = (
    useShowWorkbooksAsViews: boolean,
    showWorkbooksAsViews: boolean,
    flowsEnabled: boolean
  ): MixedContentItemDefinition[] => {
    const items: MixedContentItemDefinition[] = [];

    for (const typeDef of MixedContentInOrder) {
      if (
        (typeDef.itemType === FlowDefinition.contentType && !flowsEnabled) ||
        (typeDef.itemType === MetricDefinition.contentType && !FeatureFlags.metricsSpaceEnabled) ||
        (typeDef.itemType === PublishedConnectionDefinition.contentType && !FeatureFlags.publishedConnectionContentManagementSP1Enabled)) {
        continue;
      }

      if (useShowWorkbooksAsViews) {
        if (!showWorkbooksAsViews && typeDef === ViewDefinition) {
          // Showing workbooks only.
          continue;
        } else if (showWorkbooksAsViews && typeDef === WorkbookDefinition) {
          // Showing views instead.
          continue;
        }
      }
      items.push(typeDef);
    }

    return items;
  };

  export const showingViewsOrWorkbooks = (currentTypeFilters: ReadonlyArray<ExplorableItemType>): boolean => {
    return _.some(currentTypeFilters, (contentType: ExplorableItemType) => {
      return contentType === WorkbookDefinition.contentType
        || contentType === ViewDefinition.contentType;
    });
  };

  export const isCurrentlyFilteredContentType = (value: string, currentTypeFilters: ReadonlyArray<ExplorableItemType>) => {
    return _.some(currentTypeFilters, (selectedItem) => {
      if (selectedItem === 'dataconnection') {
        return value === 'datasource';
      }
      return selectedItem === value;
    });
  };

}
